import dayjs from 'dayjs';

export function getEstablishedYearOptions() {
  const currentYear = dayjs().year();
  const yearSequence = [...Array(currentYear - 1989).keys()];
  const years = yearSequence.map((difference) => ({
    label: currentYear - difference,
    value: currentYear - difference,
  }));

  return years;
}

// TODO need definitions for most liked, rising star, and SFT favs
// Make sure any variables are available in catering_request.json.jbuilder (for TruckProfilePane)
export function getTruckBadgeMap(truck) {
  const establishedYear = dayjs().set('year', parseInt(truck.established_year));
  const age = dayjs().diff(establishedYear, 'years');

  return [
    {
      description: 'Food truck',
      imageName: 'truck',
      key: 'truck',
      show: !truck.trailer && !truck.cart,
    }, {
      description: 'Food trailer',
      imageName: 'trailer',
      show: truck.trailer,
    }, {
      description: 'Food cart',
      imageName: 'cart',
      show: truck.cart,
    }, {
      description: 'Takes credit cards',
      imageName: 'cards',
      show: truck.accepts_credit_cards,
    }, {
      description: `Est. ${truck.established_year}`,
      imageName: 'rookie',
      show: truck.established_year && age <= 2,
    }, {
      description: `Est. ${truck.established_year}`,
      imageName: 'professional',
      show: truck.established_year && age > 2 && age <= 5,
    }, {
      description: `Est. ${truck.established_year}`,
      imageName: 'veteran',
      show: truck.established_year && age > 5,
    }, {
      description: 'Asian Owned',
      imageName: 'asian-owned',
      show: truck.asian_owned,
    }, {
      description: 'Black Owned',
      imageName: 'black-owned',
      show: truck.black_owned,
    }, {
      description: 'Latinx Owned',
      imageName: 'latinx-owned',
      show: truck.latinx_owned,
    }, {
      description: 'LGBTQ+ Owned',
      imageName: 'lgbtq-owned',
      show: truck.lgbtq_owned,
    }, {
      description: 'Veteran Owned',
      imageName: 'veteran-owned',
      show: truck.veteran_owned,
    }, {
      description: 'Women Owned',
      imageName: 'women-owned',
      show: truck.woman_owned,
    }, {
      description: 'Most Booked',
      imageName: 'most-booked',
      show: truck.most_booked,
    }, {
      description: 'Most Liked',
      imageName: 'most-liked',
      show: truck.most_liked,
    }, {
      description: 'Rising Star',
      imageName: 'rising-star',
      show: truck.rising_star,
    }, {
      description: 'SFT Favs',
      imageName: 'sft-favs',
      show: truck.sft_favs,
    }, {
      description: 'Health Permit Verified',
      imageName: 'health-permit',
      show: truck.health_status === 'approved' || truck.health_county2_status === 'approved',
    }, {
      description: 'Fully Licensed & Insured',
      imageName: 'licensed-insured',
      show: truck.coi_status === 'approved',
    }, {
      description: 'Contactless Payment Accepted',
      imageName: 'contactless',
      show: truck.accepts_apple_pay || truck.accepts_google_pay,
    }
  ].filter(({ show }) => show);
}
